import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "42.174",
  width: "50",
  viewBox: "0 0 50 42.174",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M6.447.004L3.93 2.52l39.656 39.658 2.52-2.516L6.446.004zm18.536 8.52c-2.35 0-4.627.143-6.798.463l3.24 3.24 2.312-.18c-.64.108-1.28.25-1.886.5L33.42 24.11c.392-.997.57-2.064.57-3.168s-.214-2.242-.677-3.31c-.64.926-1.71 1.53-2.917 1.53-1.993 0-3.595-1.6-3.595-3.593 0-1.248.606-2.316 1.567-2.956-.64-.25-1.317-.427-2.064-.534 13.165.32 20.175 5.268 20.175 8.898 0 2.632-3.416 5.444-9.074 7.19l2.777 2.774C46.193 28.704 50 25.108 50 20.98c0-6.05-8.755-12.455-25.018-12.455zM9.61 11.087C3.736 13.33 0 16.887 0 20.945 0 27.92 10.997 33.4 25.018 33.4c2.242 0 4.413-.142 6.477-.39l-3.24-3.31-1.956.106c.565-.07 1.1-.213 1.633-.39l-11.388-11.39c-.32.926-.498 1.887-.498 2.92 0 4.52 3.344 8.255 7.686 8.86-11.957-.32-20.178-4.804-20.178-8.86 0-2.6 3.308-5.34 8.824-7.083l-2.777-2.775z"
  })]
});